import { forwardRef, useState } from 'react';
import './inputTextLogin.css';
import { Eye, EyeOff } from 'lucide-react'; // <- Agora isso vai funcionar!

const InputTextLogin = forwardRef(({
    titulo,
    tipo,
    valor,
    onChange,
    onKeyDown,
    readOnly,
    onFocus,
    autoComplete,
    name,
    onBlur,
    maxLength
}, ref) => {
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const isPassword = tipo === 'password';
    const tipoCampo = isPassword ? (mostrarSenha ? 'text' : 'password') : tipo;

    return (
        <div className='linput-text-login' style={{ position: 'relative' }}>
            <label htmlFor={name}>{titulo}</label>

            <input
                readOnly={readOnly}
                ref={ref}
                type={tipoCampo}
                value={valor}
                autoComplete={autoComplete}
                id={name}
                name={name}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onFocus={onFocus}
                onBlur={onBlur}
                maxLength={maxLength}
                style={isPassword ? { paddingRight: '2.5rem' } : {}}
            />

            {isPassword && (
                <button
                    type="button"
                    onClick={() => setMostrarSenha(prev => !prev)}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '60%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    tabIndex={-1}
                >
                    {mostrarSenha ? <Eye size={18} color="#fff" /> : <EyeOff size={18} color="#fff" />}
                </button>
            )}
        </div>
    );
});

export default InputTextLogin;
